import type { Route } from '@metro/routing'
import type { SchemaData } from '../schema/types'

/**
 * Admits an online route only when every id in it exists in the schema the
 * route will be drawn on — each stop's station id and each ride's line id.
 * A route naming anything else cannot be highlighted on the map, and its
 * rows render raw ids with fallback-grey line badges (TASK-986: a v1 answer
 * on the v2 map, or a stale server). Such routes are dropped so the adapter
 * falls back to the offline graph, which is built from the same schema and
 * therefore always matches it. Port of iOS `OnlineRouteSchemaGuard` and the
 * Android twin.
 */
export function buildOnlineRouteSchemaGuard(schema: SchemaData): (route: Route) => boolean {
  const stationIds = new Set(schema.stations.map((s) => s.id))
  const lineIds = new Set(schema.stations.map((s) => s.line.id))
  return (route) =>
    route.legs.every((leg) => {
      if (leg.type === 'ride' && !lineIds.has(leg.line_id ?? '')) return false
      return (leg.stops ?? []).every((stop) => stationIds.has(stop.stationId))
    })
}
